import React from 'react';

import classNames from 'classnames';

import { getAbsoluteURL } from '@app/common/utils/url';

import styles from './FlagIcon.pcss';
import { initializeSprite } from './utils';

// eslint-disable-next-line i18next/no-literal-string
initializeSprite(getAbsoluteURL('media/img/flags/sprite.svg'));

export interface FlagIconProps {
  readonly className?: string;
  readonly country: string;
}

export const FlagIcon = ({ className, country }: FlagIconProps) => (
  <svg
    data-stable-name="CountryFlagIcon"
    className={classNames(styles.icon, className)}
  >
    <use
      data-stable-name="CountryFlagRef"
      href={`#${country}`}
    />
  </svg>
);
